"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MailSelectQueryBuilder = exports.WhereType = exports.Mail = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _SelectQueryBuilder2 = require("../../../utils/query-builder/SelectQueryBuilder");

var _utils = require("../../../utils");

var _char = require("../../../utils/char");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Mail = /*#__PURE__*/function () {
  (0, _createClass2["default"])(Mail, [{
    key: "content",
    get: function get() {
      return this._content;
    },
    set: function set(content) {
      this._content = content.slice();
    }
  }, {
    key: "data",
    get: function get() {
      return this._content.map(function (content) {
        return content.str;
      });
    }
    /**
     * @deprecated
     */
    ,
    set: function set(data) {
      console.warn("Should not set Mail.data/Mail.lines directly. " + "Use Mail.content instead");
    }
  }]);

  function Mail() {
    (0, _classCallCheck2["default"])(this, Mail);
    (0, _defineProperty2["default"])(this, "id", void 0);
    (0, _defineProperty2["default"])(this, "date", void 0);
    (0, _defineProperty2["default"])(this, "timestamp", void 0);
    (0, _defineProperty2["default"])(this, "author", void 0);
    (0, _defineProperty2["default"])(this, "status", void 0);
    (0, _defineProperty2["default"])(this, "title", void 0);
    (0, _defineProperty2["default"])(this, "_content", []);
  }

  (0, _createClass2["default"])(Mail, [{
    key: "hasHeader",
    value: function hasHeader() {
      if (this.content.length === 0) {
        return false;
      }

      var authorArea = (0, _char.substrWidth)('dbcs', this.content[0].str, 0, 6).trim();
      return authorArea === '作者';
    }
  }], [{
    key: "fromLine",
    value: function fromLine(line) {
      var mail = new Mail();
      var str = line.str;
      mail.id = +(0, _char.substrWidth)('dbcs', str, 1, 5).trim();
      mail.date = (0, _char.substrWidth)('dbcs', str, 9, 5).trim();
      mail.author = (0, _char.substrWidth)('dbcs', str, 15, 12).trim();
      mail.status = (0, _char.substrWidth)('dbcs', str, 30, 2).trim();
      mail.title = (0, _char.substrWidth)('dbcs', str, 33).trim();
      return mail;
    }
  }, {
    key: "select",
    value: function select(bot) {
      return new MailSelectQueryBuilder(bot);
    }
  }]);
  return Mail;
}();

exports.Mail = Mail;
var WhereType;
exports.WhereType = WhereType;

(function (WhereType) {
  WhereType["Id"] = "id";
  WhereType["Author"] = "author";
  WhereType["Title"] = "title";
})(WhereType || (exports.WhereType = WhereType = {}));

var MailSelectQueryBuilder = /*#__PURE__*/function (_SelectQueryBuilder) {
  (0, _inherits2["default"])(MailSelectQueryBuilder, _SelectQueryBuilder);

  var _super = _createSuper(MailSelectQueryBuilder);

  function MailSelectQueryBuilder(bot) {
    var _this;

    (0, _classCallCheck2["default"])(this, MailSelectQueryBuilder);
    _this = _super.call(this);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "bot", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "wheres", []);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "id", 0);
    _this.bot = bot;
    return _this;
  }

  (0, _createClass2["default"])(MailSelectQueryBuilder, [{
    key: "where",
    value: function where(type, condition) {
      switch (type) {
        case WhereType.Id:
          this.id = +condition;
          break;

        case WhereType.Author:
          this.wheres.push({
            type: 'a',
            condition: condition
          });
          break;

        case WhereType.Title:
          this.wheres.push({
            type: '/',
            condition: condition
          });
          break;

        default:
          throw new Error("Invalid type: ".concat(type));
      }

      return this;
    }
  }, {
    key: "getQuery",
    value: function getQuery() {
      return this.wheres.map(function (_ref) {
        var type = _ref.type,
            condition = _ref.condition;
        return "".concat(type).concat(condition).concat(_utils.keymap.Enter);
      }).join();
    }
  }, {
    key: "get",
    value: function () {
      var _get = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var found, id, mails, i, line, mail;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.bot.enterMail();

              case 2:
                _context.next = 4;
                return this.bot.send(this.getQuery());

              case 4:
                found = _context.sent;

                if (found) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", []);

              case 7:
                if (!(this.id > 0)) {
                  _context.next = 11;
                  break;
                }

                id = Math.max(this.id - 9, 1);
                _context.next = 11;
                return this.bot.send("".concat(_utils.keymap.End).concat(_utils.keymap.End).concat(id).concat(_utils.keymap.Enter));

              case 11:
                mails = [];
                i = 3;

              case 13:
                if (!(i <= 22)) {
                  _context.next = 22;
                  break;
                }

                line = this.bot.line[i];

                if (!(line.str.trim() === '')) {
                  _context.next = 17;
                  break;
                }

                return _context.abrupt("break", 22);

              case 17:
                mail = Mail.fromLine(line);
                mails.push(mail);

              case 19:
                i++;
                _context.next = 13;
                break;

              case 22:
                _context.next = 24;
                return this.bot.enterIndex();

              case 24:
                return _context.abrupt("return", mails.reverse());

              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function get() {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "getOne",
    value: function () {
      var _getOne = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var found, mail;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.bot.enterMail();

              case 2:
                _context2.next = 4;
                return this.bot.send(this.getQuery());

              case 4:
                found = _context2.sent;

                if (found) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt("return", void 0);

              case 7:
                _context2.next = 9;
                return this.bot.send("".concat(this.id).concat(_utils.keymap.Enter).concat(_utils.keymap.Enter));

              case 9:
                mail = new Mail();
                mail.id = this.id;
                _context2.next = 13;
                return this.bot.getContent();

              case 13:
                mail.content = _context2.sent;

                if (mail.hasHeader()) {
                  mail.author = (0, _char.substrWidth)('dbcs', this.bot.line[0].str, 7, 50).trim();
                  mail.title = (0, _char.substrWidth)('dbcs', this.bot.line[1].str, 7).trim();
                  mail.timestamp = (0, _char.substrWidth)('dbcs', this.bot.line[2].str, 7).trim();
                }

                _context2.next = 17;
                return this.bot.enterIndex();

              case 17:
                return _context2.abrupt("return", mail);

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getOne() {
        return _getOne.apply(this, arguments);
      }

      return getOne;
    }()
  }]);
  return MailSelectQueryBuilder;
}(_SelectQueryBuilder2.SelectQueryBuilder);

exports.MailSelectQueryBuilder = MailSelectQueryBuilder;
var _default = Mail;
exports["default"] = _default;